module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAAAAXNSR0IArs4c6QAAAOBJREFUOE+d1M8NwiAYBfD3hQHsBroCCenZTqBOYDfRTdQJdAP1XBocwRG894BCatNayh+5kbxfvgDhEQAopRZN08zzPL+bfcyiqqqWRHRtwzfG2IZz/gphA/dEtOsFH4yxIoRJSrkGcP6ZEMRkQF3Xpdb6kIIt/Ad3MBUPYAoewVjshDF4EvqwEIJ7oQdvglBKeQSw7b+x1rrwQhcCcBJClJPQh8x0JwwhJ4xBIxiLBjAFdTAVWTjxF+2V++rDNMDl01erXiiI7MS2rAyefR83VFTdGZVSGYCMc/6MQSbzBiy6nW6MahPYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spzx_xqy/cpzx_y.png
// module id = ynKq
// module chunks = 1